const config = [
  {
    title: 'What’s the difference between a Basic Sale and Unlimited Sale?',
    description: [
      'In the Basic Sale, every user can commit a maximum of about 100 USD worth of CAKE-BNB LP Tokens. We calculate the maximum LP amount about 30 minutes before each IFO. The Basic Sale has no participation fee.',
      'In the Unlimited Sale, there’s no limit to the amount of CAKE-BNB LP Tokens you can commit. However, there’s a fee for participation: see below.',
    ],
  },
  {
    title: 'Which sale should I commit to? Can I do both?',
    description: [
      'You can choose one or both at the same time! If you’re only committing a small amount, we recommend the Basic Sale first. Just remember you need a PancakeSwap Profile in order to participate.',
    ],
  },
  {
    title: 'How much is the participation fee?',
    description: [
      'There’s only a participation fee for the Unlimited Sale: there’s no fee for the Basic Sale.',
      'The fee will start at 1%.',
      'The 1% participation fee decreases in cliffs, based on the percentage of overflow from the “Unlimited” portion of the sale.',
    ],
  },
  {
    title: 'Where does the participation fee go?',
    description: [
      'We burn it. The CAKE-BNB LP tokens from the participation fee will be decomposed. We will then use the BNB portion to market buy the CAKE equivalent, and finally throw all of the CAKE into the weekly token burn.',
    ],
  },
  {
    title: 'How can I get an achievement for participating in the IFO?',
    description: [
      'You need to contribute a minimum of about 10 USD worth of CAKE-BNB LP Tokens to either sale.',
      'You can contribute to one or both, it doesn’t matter: only your overall contribution is counted for the achievement.',
    ],
  },
]
export default config
